/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：1144
 */

"use strict"

Object.defineProperty(exports, "__esModule", {
  value: true
})
exports.ConflictType = undefined;
(function (e) {
  e[e.RM_UNEXPECTED_CONTENT = 1] = "RM_UNEXPECTED_CONTENT"
  e[e.DROP_COLLISION = 2] = "DROP_COLLISION"
  e[e.BLACKHOLE = 3] = "BLACKHOLE"
})(exports.ConflictType || (exports.ConflictType = {}))
